import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { UUID } from 'v2/core/entities/uuid';
import { getTokenFromSavedSlug } from 'v2/core/services/savedSlug/utils';

// interface ParamTypes {
//   savedSlug?: string;
// }

interface SavedSlugInfo {
  token?: UUID;
  savedSlug?: string;
}

const useParseSavedSlugInfo = (): SavedSlugInfo => {
  const { savedSlug } = useParams<{
    savedSlug?: string;
  }>();

  const token = useMemo(
    () => (savedSlug ? getTokenFromSavedSlug(savedSlug) : undefined),
    [savedSlug],
  );
  return { token, savedSlug };
};

export default useParseSavedSlugInfo;
